import { Helmet } from 'react-helmet';
import { useSiteMetadata } from '@hooks/useSiteMetadata';

export const SEO = () => {
  const { title, description, url, image, twitterUsername, instagramUsername } =
    useSiteMetadata();

  return (
    <Helmet
      title={title}
      htmlAttributes={{
        lang: 'es',
      }}
    >
      <meta charSet="utf-8" />
      <meta name="description" content={description} />
      <meta name="image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content={twitterUsername} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="instagram:card" content="summary_large_image" />
      <meta name="instagram:creator" content={instagramUsername} />
      <meta name="instagram:title" content={title} />
      <meta name="instagram:description" content={description} />
      <meta name="instagram:image" content={image} />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" />
      <link
        href="https://fonts.googleapis.com/css2?family=Oleo+Script+Swash+Caps:wght@700&display=swap"
        rel="stylesheet"
      ></link>
    </Helmet>
  );
};
